import { lazyLoad } from "utils/loadable";

const WarmUpTestPage = lazyLoad(
  () => import("./index"),
  (module) => module.WarmUpTestPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default WarmUpTestPage;
